/*! Liquid Glass Logo - ReactDrops Component License 1.0, Copyright (c) 2026 ReactDrops. Usage dans un site fini (End Product) autorise; redistribution comme kit/theme interdite. */
(()=>{var de=(t,a)=>()=>(t&&(a=t(t=0)),a);var Ge=(t,a)=>()=>(a||t((a={exports:{}}).exports,a),a.exports);var ge,me,pe,ve=de(()=>{ge=`#version 300 es
in vec2 aPosition;
void main() {
  gl_Position = vec4(aPosition, 0.0, 1.0);
}
`,me=`#version 300 es
precision highp float;
uniform sampler2D uLogo;
uniform sampler2D uText;
uniform vec2 uResolution;
uniform float uDpr;
uniform float uUnit;
uniform vec2 uLogoBox;
uniform vec2 uTextBox;
uniform float uTextWidth;
uniform float uTime;
uniform float uSettle;
uniform float uArtScale;
uniform float uWordmarkEnabled;
uniform vec3 uTile;
uniform float uTileEnabled;
// 0 on a dark page, 1 on a pale one.
uniform float uPageLight;
uniform float uDepth;
uniform float uDispersion;
uniform float uRelief;
uniform float uCaustics;
uniform float uHighlights;
// How much the faint line outside the rim takes the plate color.
uniform float uEchoTint;
// 0 draws the full inner wall; 1 keeps it to the upper-left and lower-right arcs.
uniform float uInnerWallFocus;
uniform float uDropSize;
uniform float uDropStrength;
uniform float uDecay;
// Second drop: radius, core radius, rim stretch, center factor (negative inverts).
uniform vec4 uDrop;
// Second drop: core edge magnification, profile exponent, ripple amplitude, wavelength.
uniform vec4 uDropLens;
// Second drop: ripple phase, share of ripples inside the core, dispersion, unused.
uniform vec4 uDropWave;
out vec4 outColor;
const float PI = 3.14159265359;
const int BANDS = 32;

float sq(float x) { return x * x; }
float bell(float x, float width) { return exp(-sq(x / max(width, 0.001))); }
float ease(float a, float b, float x) { return smoothstep(a, b, x); }

// Smooth overlapping spectral sensitivities, normalized in the integration below.
vec3 spectrum(float s) {
  float wavelength = 400.0 + 300.0 * s;
  vec3 rgb = vec3(0.0);
  if (wavelength < 440.0) rgb = vec3((440.0 - wavelength) / 120.0, 0.0, 1.0);
  else if (wavelength < 490.0) rgb = vec3(0.0, (wavelength - 440.0) / 50.0, 1.0);
  else if (wavelength < 510.0) rgb = vec3(0.0, 1.0, (510.0 - wavelength) / 20.0);
  else if (wavelength < 580.0) rgb = vec3((wavelength - 510.0) / 70.0, 1.0, 0.0);
  else if (wavelength < 645.0) rgb = vec3(1.0, (645.0 - wavelength) / 65.0, 0.0);
  else rgb = vec3(1.0, 0.0, 0.0);
  return rgb * mix(0.2, 1.0, ease(400.0, 430.0, wavelength)) * mix(1.0, 0.65, ease(650.0, 700.0, wavelength));
}
float glassIor(float s, float spread) {
  float wavelength = 0.4 + 0.3 * s;
  return 1.38 + (0.04 / (wavelength * wavelength) - 0.12) * spread;
}

vec4 imageAt(sampler2D image, vec2 p, vec2 box) {
  vec2 uv = 0.5 + p / box;
  // Transparent outside the image, including images that touch their texture edges.
  // Explicit LOD is stable inside the back-face branch; implicit derivatives are
  // undefined there and can make the same sought frame change after another draw.
  vec2 footprint = vec2(textureSize(image, 0)) / max(box * uDpr, vec2(1.0));
  float lod = max(0.0, log2(max(footprint.x, footprint.y)));
  // The first sphere comes into focus as it flattens into a plate.
  lod += (1.0 - ease(0.20, 0.36, uTime)) * 2.2;
  vec4 ink = textureLod(image, uv, lod);
  return ink * step(0.0, uv.x) * step(0.0, uv.y) * step(uv.x, 1.0) * step(uv.y, 1.0);
}

float superRadius(vec2 p, float n) {
  vec2 a = max(abs(p), vec2(0.00001));
  return pow(pow(a.x, n) + pow(a.y, n), 1.0 / n);
}
vec2 superNormal(vec2 p, float n) {
  return normalize(sign(p) * pow(max(abs(p), vec2(0.00001)), vec2(n - 1.0)) + vec2(0.000001));
}

float hash1(float n) { return fract(sin(n * 127.1 + 311.7) * 43758.5453); }

// Real glass is not a perfect stroke. Along an edge (u = arc length in pixels) its
// light varies slowly and breaks into short glints where the surface is uneven.
float contourNoise(float u) {
  float i = floor(u);
  float f = fract(u);
  f = f * f * (3.0 - 2.0 * f);
  return mix(hash1(i), hash1(i + 1.0), f);
}
float specks(float u, float d, float size, float seed) {
  float spacing = size * 22.0;
  float cell = floor(u / spacing);
  float on = step(0.7, hash1(cell + seed));
  float center = (cell + 0.2 + 0.6 * hash1(cell + seed + 17.0)) * spacing;
  float offset = (hash1(cell + seed + 31.0) - 0.5) * size * 0.6;
  // Glints are dashes along the edge, several times longer than they are wide.
  float dash = size * (2.5 + 4.0 * hash1(cell + seed + 53.0));
  return on * bell(u - center, dash) * bell(d - offset, size * 0.35);
}
// The same glints as particles held by the liquid: each one bobs across the edge
// on its own period and barely sways along it, so nothing slides sideways.
// Neighboring cells are included so a moving glint is not clipped at its cell.
float driftingSpecks(float u, float d, float size, float seed, float t) {
  float spacing = size * 22.0;
  float cell = floor(u / spacing);
  float glints = 0.0;
  for (int j = -1; j <= 1; j++) {
    float id = cell + float(j);
    float on = step(0.7, hash1(id + seed));
    float rate = 2.5 + 3.0 * hash1(id + seed + 71.0);
    float phase = 6.2832 * hash1(id + seed + 89.0);
    float center = (id + 0.2 + 0.6 * hash1(id + seed + 17.0)) * spacing + sin(t * rate * 0.5 + phase) * spacing * 0.05;
    float offset = (hash1(id + seed + 31.0) - 0.5) * size * 0.6 + sin(t * rate + phase) * size * 1.6;
    float dash = size * (2.5 + 4.0 * hash1(id + seed + 53.0));
    glints += on * bell(u - center, dash) * bell(d - offset, size * 0.35);
  }
  return min(glints, 1.0);
}

// Material-space relief: neighboring glass walls share the slow undulation but
// have different fine thickness variations. It stays attached as the lens grows.
float edgeWarp(float arc, float seed) {
  float broad = contourNoise(arc / (uUnit * 0.037) + seed) - 0.5;
  float fine = contourNoise(arc / (uUnit * 0.008) + seed + 29.0) - 0.5;
  return uUnit * (broad * 0.0017 + fine * 0.0008);
}

// Small flattened air pockets in the glass channel. x is the dark cavity;
// y is its light-catching lip. Three cells avoid popping at cell boundaries.
vec2 glassPores(float arc, float d, float seed) {
  if (abs(d) > uUnit * 0.011) return vec2(0.0);
  float pitch = uUnit * 0.022;
  float cell = floor(arc / pitch);
  vec2 pores = vec2(0.0);
  for (int j = -1; j <= 1; j++) {
    float id = cell + float(j) + seed;
    float visible = step(0.63, hash1(id));
    float center = (cell + float(j) + 0.15 + 0.7 * hash1(id + 17.0)) * pitch;
    float across = (hash1(id + 31.0) - 0.5) * uUnit * 0.009;
    float span = uUnit * (0.0022 + 0.0035 * hash1(id + 53.0));
    float height = max(0.35 / uDpr, uUnit * (0.0007 + 0.0012 * hash1(id + 71.0)));
    vec2 q = vec2((arc - center) / span, (d - across) / height);
    // A slight skew keeps the cavities from forming identical ellipses.
    q.x += q.y * (hash1(id + 89.0) - 0.5) * 0.55;
    float radius = length(q);
    float aa = max(0.18, 0.4 / (uDpr * height));
    float cavity = bell(radius, 0.65);
    float lip = bell(radius - 1.0, aa);
    float glint = 0.25 + 0.75 * max(dot(q / max(radius, 0.001), normalize(vec2(-0.4, 0.8))), 0.0);
    pores += vec2(cavity, lip * glint) * visible;
  }
  return min(pores, vec2(1.0));
}

// Light reflected off the ripples outside the glass is invisible on a pale page.
// There the same ripples bend the page away and read as cool shadows, as in the
// light reference. Coverage is unchanged, so a dark page renders as before.
vec3 exteriorColor(vec3 light, float coverage) {
  // The shadow leans toward the plate's own tone, a little deeper, so it belongs
  // to the glass instead of reading as a gray smudge on the page.
  vec3 shade = mix(vec3(0.40, 0.46, 0.56), uTile * 0.86, uEchoTint);
  return mix(light, shade * coverage, uPageLight);
}

// Per-channel coverage of the last refracted image. Each wavelength band lands
// on the artwork at its own offset, so a dark logo over a light plate blocks red,
// green and blue at slightly different places and its edges split into color.
vec3 refractedCoverage;

// A refracted image behind a glass lens, with a little light focused onto its ink.
vec4 refractedLogo(vec2 p, vec2 normalXY, float lensScale, float glass, float chromaticScale, float surfaceDistance) {
  vec3 normal = normalize(vec3(normalXY, 1.0));
  vec3 color = vec3(0.0);
  vec3 weights = vec3(0.0);
  float alpha = 0.0;
  float minCoverage = 1.0;
  float maxCoverage = 0.0;
  refractedCoverage = vec3(0.0);
  float spread = uDispersion * chromaticScale * mix(0.85, mix(2.2, 1.5, ease(0.28, 0.9, uTime)), ease(0.25, 0.33, uTime));
  vec3 neutralRay = refract(vec3(0.0, 0.0, -1.0), normal, 1.0 / glassIor(0.5, spread));
  vec2 neutralOffset = neutralRay.xy / max(-neutralRay.z, 0.25) * uUnit * uDepth * 0.80 * lensScale;
  for (int i = 0; i < BANDS; i++) {
    float s = float(i) / float(BANDS - 1);
    // Shorter wavelengths bend more. Dispersion is intentionally visible at the bevel.
    // The young sphere splits light only at its rim; the settled bevel splits it strongly.
    float ior = glassIor(s, spread);
    vec3 ray = refract(vec3(0.0, 0.0, -1.0), normal, 1.0 / ior);
    vec2 offset = ray.xy / max(-ray.z, 0.25) * uUnit * uDepth * 0.80 * lensScale;
    // Measured artwork scale over time; see artworkScale in the renderer.
    float artworkScale = uArtScale;
    float magnification = 1.0;
    // The opening focus folds the edge of the image into a partial crescent.
    // It opens into barrel distortion before the sphere flattens into the plate.
    float sphereRadius = uUnit * lensScale * 0.5;
    float sphereFocus = 1.0 - ease(0.225, 0.335, uTime);
    float bubbleQ = min(length(p) / max(sphereRadius, 1.0), 1.0);
    float openingFocus = 1.0 - ease(0.19, 0.265, uTime);
    float focusProfile = mix(0.7 + 0.6 * sq(bubbleQ), 1.0 - 0.9 * sq(bubbleQ), openingFocus);
    vec2 bubbleSample = p * focusProfile + offset * mix(0.35, 0.12, openingFocus);
    bubbleSample += vec2(0.025, 0.10) * uUnit * openingFocus;
    bubbleSample += (offset - neutralOffset) * openingFocus * 1.6;
    vec2 sourcePoint = mix(p + offset, bubbleSample, sphereFocus);
    vec4 ink = imageAt(uLogo, sourcePoint, uLogoBox * artworkScale * magnification);
    // Focus is inside the young dome, leaving clear glass between the enlarged
    // fragment and the rim. The aperture opens as the rest of the logo appears.
    ink *= mix(1.0, 1.0 - ease(0.72, 0.86, bubbleQ), openingFocus);
    // The rim is an optical aperture too. Giving each wavelength its own boundary
    // creates a red/yellow outer edge and cyan/blue inner edge without tinting the ink.
    float edgeShift = (s - 0.5) * uUnit * lensScale * 0.018 * uDispersion * chromaticScale;
    ink *= 1.0 - smoothstep(-0.8 / uDpr, 0.8 / uDpr, surfaceDistance - edgeShift);
    minCoverage = min(minCoverage, ink.a);
    maxCoverage = max(maxCoverage, ink.a);
    vec3 w = spectrum(s);
    color += ink.rgb * w;
    alpha += ink.a * (w.r + w.g + w.b);
    refractedCoverage += ink.a * w;
    weights += w;
  }
  color /= weights;
  refractedCoverage /= weights;
  // A coated glass shoulder has a cooler spectral response at a split image edge.
  // Coverage variance keeps solid areas and original-color artwork free of a tint.
  float coating = ease(-uUnit * lensScale * 0.022, 0.0, surfaceDistance);
  color.g *= 1.0 - 0.65 * coating * (maxCoverage - minCoverage);
  // The young curved face catches a violet interference fringe at internal ink
  // edges. Its outer lip stays cyan; opaque artwork keeps its original color.
  float youngFilm = (maxCoverage - minCoverage) * (1.0 - ease(0.19, 0.30, uTime));
  youngFilm *= 1.0 - ease(-uUnit * lensScale * 0.08, -uUnit * lensScale * 0.025, surfaceDistance);
  color.r += color.b * youngFilm * 0.80;
  color.b += color.r * youngFilm * 0.60;
  color.g *= 1.0 - youngFilm * 0.55;
  alpha /= weights.r + weights.g + weights.b;
  // This lift belongs to the image's edges, not a painted rainbow on the lens.
  float diffuse = max(dot(normal, normalize(vec3(-0.4, 0.6, 1.0))), 0.0);
  vec3 earlyWhite = mix(vec3(0.90, 0.93, 0.95), vec3(0.84, 0.86, 0.89), ease(0.21, 0.40, uTime));
  vec3 whiteBalance = mix(earlyWhite, vec3(0.87, 0.88, 0.885), ease(0.75, 1.22, uTime));
  color *= whiteBalance * ((0.90 + 0.10 * diffuse + glass * uCaustics * 0.04) * ((0.975 + 0.025 * sin(p.y / uUnit * PI)) * (1.0 + 0.09 * ease(0.75, 1.22, uTime) + 0.03 * (1.0 - ease(0.2, 0.5, uTime)))));
  return vec4(color, alpha);
}

vec4 iconLens(vec2 p) {
  float t = uTime;
  float settle = ease(0.0, 1.0, uSettle);
  float enter = ease(0.025, 0.16, t);
  vec4 source = imageAt(uLogo, p, uLogoBox * uArtScale);
  if (t > 1.58) return source * settle;
  if (enter < 0.001) return vec4(0.0);
  float shape = 2.0 + 3.0 * ease(0.29, 0.36, t);
  // The sphere appears quickly, then the glass continues expanding after the
  // corners have squared off. Completing both motions at once feels abrupt.
  float expand = enter * (0.64 + 0.41 * (1.0 - exp(-max(t - 0.16, 0.0) * 5.8)));
  float collapse = 1.0 - ease(1.33, 1.52, t);
  float lensScale = max(0.001, mix(expand * mix(0.48, 1.0, collapse), 1.0, settle));
  float halfSize = uUnit * 0.5 * lensScale;
  float radius = superRadius(p / halfSize, shape);
  float sd = (radius - 1.0) * halfSize;
  float aa = max(fwidth(sd), 0.65);
  float mask = (1.0 - smoothstep(-aa, aa, sd));
  float glass = (1.0 - ease(1.05, 1.4, t)) * collapse * (1.0 - settle);
  float shown = ease(0.12, 0.165, t) * (1.0 - ease(1.39, 1.53, t));
  // Nothing is drawn beyond the thin echo just outside the rim.
  if (sd > uUnit * 0.10) return vec4(0.0);
  vec2 outward = superNormal(p / halfSize, shape);
  // A flat center rolls into a thick, curved shoulder. The normal continuously bends
  // source rays into the plate and folds them at its rim, whatever the source image.
  vec2 radial = normalize(p + vec2(0.001));
  float diagonal = max(0.0, 2.0 * radial.x * radial.y);
  float shoulderStart = 0.6 + 0.18 * ease(0.66, 1.15, t) * (1.0 - diagonal) + 0.16 * ease(1.0, 1.22, t) * diagonal;
  float shoulder = ease(shoulderStart, 1.0, radius);
  float slope = (0.04 * radius + (0.85 + 0.2 * (1.0 - ease(0.28, 0.75, t))) * shoulder * shoulder) * glass * uDropStrength;
  // The early sphere is rounder and more strongly magnifying than the settled tile.
  slope += (1.0 - ease(0.18, 0.42, t)) * radius * 0.32 * uDropStrength;
  vec2 opticalDirection = normalize(mix(outward, normalize(p + vec2(0.001)), 0.95));
  // A mild astigmatic shoulder carries the image into opposite corners.
  float astigmatism = 0.8 + 0.4 * radial.x * radial.y;
  vec2 n = opticalDirection * slope * astigmatism * (1.0 - settle);
  vec4 ink = refractedLogo(p, n, lensScale, glass, 1.0, sd);
  float illumination = 0.5 + 0.5 * dot(outward, normalize(vec2(-0.5, 0.9)));
  vec3 inkCoverage = refractedCoverage;
  // A dark plate deepens toward its rim; a pale frosted plate stays nearly even.
  float plateLight = ease(0.3, 0.8, dot(uTile, vec3(0.299, 0.587, 0.114)));
  vec3 body = uTile * (mix(0.55, 0.96, plateLight) + mix(0.45, 0.04, plateLight) * (1.0 - min(radius, 1.0)));
  body += vec3(0.004, 0.007, 0.01) * bell(radius - 0.75, 0.5);
  vec3 color = ink.rgb + body * (1.0 - inkCoverage) * glass * uTileEnabled;
  // On a pale page the plate's coverage follows the glass exactly, so its color
  // keeps the same hue while it melts into the page instead of dipping and
  // flaring. A dark page keeps its original fade.
  float plateFade = mix((1.0 - ease(1.08, 1.36, t)) * (1.0 - settle), glass, uPageLight);
  float alpha = max(ink.a, plateFade * uTileEnabled);
  // A broad studio light is reflected by the curved front face of the sphere.
  // It fades as the face flattens, revealing the dark glass beneath the artwork.
  vec2 spherePoint = p / halfSize;
  vec3 sphereNormal = normalize(vec3(spherePoint, sqrt(max(0.001, 1.0 - dot(spherePoint, spherePoint)))));
  vec3 sphereRay = reflect(vec3(0.0, 0.0, -1.0), sphereNormal);
  float lightTravel = mix(-0.12, 0.20, ease(0.13, 0.30, t));
  float softbox = bell(sphereRay.x - lightTravel, 1.05) * bell(sphereRay.y - 0.56, 0.52);
  float sphericalLight = softbox * (1.0 - ease(0.245, 0.36, t)) * glass * uHighlights * 0.70;
  color += vec3(0.50, 0.61, 0.72) * sphericalLight * (1.0 - ink.a * 0.85);
  alpha = max(alpha, sphericalLight);

  // Thin nested surface reflections, with asymmetric key light and a dim cool fill.
  // Material coordinates stay fixed during expansion and deterministic seeking.
  float arc = atan(p.y, p.x) * uUnit * 0.5;
  float grainScale = uUnit * 0.03;
  float developed = ease(0.23, 0.48, t);
  float cornerExposure = ease(0.12, 0.8, -2.0 * radial.x * radial.y);
  float reliefScale = lensScale * developed * (0.2 + 0.8 * cornerExposure);
  float sharedWarp = edgeWarp(arc, 0.0) * reliefScale;
  float rimSd = sd + sharedWarp;
  float innerSd = sd + sharedWarp * 0.7 + edgeWarp(arc, 41.0) * reliefScale * 0.4;
  float inner2Sd = sd + sharedWarp * 0.45 + edgeWarp(arc, 83.0) * reliefScale * 0.6;
  float thickness = 0.75 + 0.5 * contourNoise(arc / (uUnit * 0.013) + 13.0);
  // The bright rim line is a liquid edge, not an etched one. Its segments shimmer
  // in place and it bobs slightly across the edge as standing waves, so nothing
  // slides along it; its glints move as separate particles.
  float around = arc / (uUnit * 0.5);
  float rimBob = uUnit * 0.0025 * developed * (0.6 * sin(7.0 * around + 0.4) * sin(t * 6.3 + 1.0) + 0.4 * sin(3.0 * around + 2.0) * sin(t * 4.1));
  float rimLineSd = rimSd + rimBob;
  float shimmer = mix(contourNoise(arc / grainScale), contourNoise(arc / grainScale + 211.0), 0.5 + 0.5 * sin(t * 5.0 + 6.2832 * contourNoise(arc / (grainScale * 3.0) + 7.0)));
  float rim = bell(rimLineSd + uUnit * 0.002, uUnit * 0.0018 * thickness + aa * 0.3) * (0.6 + 0.8 * shimmer);
  // The nested lines nearer the center clear first; the outer rim lingers.
  float centerFade = 1.0 - ease(0.62, 0.92, t);
  float inner = centerFade * bell(innerSd + uUnit * 0.012, uUnit * 0.0025 / thickness + aa * 0.2) * (0.55 + 0.9 * contourNoise(arc / grainScale + 41.0));
  float inner2 = centerFade * bell(inner2Sd + uUnit * 0.022, uUnit * 0.0018 * thickness + aa * 0.1) * (0.5 + contourNoise(arc / grainScale + 83.0));
  float key = pow(illumination, 5.0);
  float rimVisibility = 1.0 - 0.55 * ease(0.75, 1.22, t);
  float lowerRight = pow(0.5 + 0.5 * dot(outward, normalize(vec2(0.8, -0.6))), 5.0);
  lowerRight *= ease(-0.25, -0.05, p.x / uUnit) * (1.0 - ease(-0.22, -0.02, p.y / uUnit));
  // Two separated walls, not two strokes at the same edge. The back wall is
  // inset by 7% of a tile edge, leaving a curved transmission channel between them.
  vec2 insetPoint = p - vec2(0.002, -0.002) * uUnit * lensScale;
  float wallGap = (0.055 - 0.023 * ease(0.18, 0.34, t)) + 0.050 * ease(0.14, 0.50, t) * (1.0 - 0.5 * ease(0.80, 1.22, t));
  float insetHalf = halfSize - wallGap * uUnit * lensScale;
  // The back face rounds off slightly later, giving the sphere and tile two visible
  // moving boundaries rather than scaling a second outline with the front face.
  float insetShape = max(2.0, 2.0 + (shape - 2.0) * ease(0.20, 0.55, t) - 0.45);
  float insetRadius = superRadius(insetPoint / insetHalf, insetShape);
  float insetSd = (insetRadius - 1.0) * insetHalf + sharedWarp * 0.4 + edgeWarp(arc, 151.0) * reliefScale * 0.7;
  float channel = ease(-uUnit * 0.008, uUnit * 0.025, insetSd) * mask;
  float echoMask = channel * lowerRight * glass * (1.0 - settle);
  vec3 backFace = vec3(0.0);
  float logoLight = 0.0;
  if (echoMask * uRelief > 0.002) {
    vec2 backNormal = normalize(mix(superNormal(insetPoint / insetHalf, insetShape), radial, 0.6));
    float backSlope = ease(0.90, 1.10, insetRadius) * 1.55 * glass * uDropStrength;
    // Sample a separate transmitted image across the whole bevel channel. Its
    // changing normal pulls a second, chromatically split copy of the logo into it.
    // A thick rim magnifies whatever lies closest behind it. Walk inward from the
    // wall until the ray meets ink and refract from there, so every logo lights
    // this corner from its own nearest shape; a logo with ink at the corner (like
    // X) is found on the first step and keeps its direct image.
    // The search starts where the wall already sends the ray, not at the wall.
    vec2 inward = -normalize(insetPoint + vec2(0.001));
    vec3 backRay = refract(vec3(0.0, 0.0, -1.0), normalize(vec3(backNormal * backSlope, 1.0)), 1.0 / 1.38);
    vec2 landing = insetPoint + backRay.xy / max(-backRay.z, 0.25) * uUnit * uDepth * 0.80 * lensScale;
    float reach = 0.0;
    for (int i = 0; i < 20; i++) {
      reach = float(i) * uUnit * lensScale * 0.03;
      if (imageAt(uLogo, landing + inward * reach, uLogoBox * uArtScale).a > 0.2) break;
    }
    vec4 backImage = refractedLogo(insetPoint + inward * reach, backNormal * backSlope, lensScale, glass, 1.6, sd);
    backFace = backImage.rgb * vec3(0.03, 0.65, 1.0) * echoMask * 0.48 * uRelief * (1.0 - 0.70 * ease(0.75, 1.12, t));
    // The lower-right light is this same refracted image, not a fixed lamp: it
    // only lights where the back wall bends logo ink into the bevel, and takes
    // that ink's shape as the logo or the refraction changes.
    logoLight = ease(0.05, 0.6, backImage.a);
  }
  lowerRight *= logoLight;
  float wallRim = centerFade * bell(insetSd, uUnit * 0.0028 + aa * 0.25);
  float wallShadow = centerFade * bell(insetSd + uUnit * 0.008, uUnit * 0.005);
  vec2 pores = vec2(0.0);
  if (developed * cornerExposure > 0.001) {
    pores = glassPores(arc, (rimSd + uUnit * 0.003) / lensScale, 313.0);
    pores += glassPores(arc, insetSd / lensScale, 617.0) * 0.6 * centerFade;
    pores += glassPores(arc, (inner2Sd + uUnit * 0.027) / lensScale, 919.0) * 0.8 * centerFade;
    pores *= developed * cornerExposure;
  }
  float angle = atan(p.y, p.x);
  float upperSliver = 0.12 + 1.15 * bell(angle - 2.18, 0.32);
  float lowerSliver = 0.12 + 1.10 * bell(angle + 0.85, 0.30);
  // The inner wall holds a brighter line around the upper-left and lower-right
  // corners, whatever the key light does. Each arc runs farther along the top or
  // bottom edge than down the side: its window is wider toward the horizontal.
  float tlOffset = angle - 0.75 * PI;
  float brOffset = angle + 0.25 * PI;
  float tlReach = tlOffset < 0.0 ? 0.65 : 0.42;
  float brReach = brOffset < 0.0 ? 0.65 : 0.42;
  float wallCorner = max(
    1.0 - ease(0.6 * tlReach, tlReach, abs(tlOffset)),
    1.0 - ease(0.6 * brReach, brReach, abs(brOffset))
  );
  vec3 insetLight = vec3(0.60, 0.78, 0.91) * wallRim * (key * key * 0.8 * upperSliver + lowerRight * lowerRight * 0.75 * lowerSliver + 0.005 + 0.35 * wallCorner * uInnerWallFocus);
  // The caustic follows the curved channel: a white-cyan core with blue lips, streaked
  // by the glass it passes through.
  // Filaments run parallel to the edge; their brightness drifts slowly along it.
  float drift = 0.7 + 0.6 * contourNoise(arc / (uUnit * 0.09) + 7.0);
  float filaments = (bell(innerSd + uUnit * 0.021, uUnit * 0.0035 * thickness) * 0.9 + bell(inner2Sd + uUnit * 0.028, uUnit * 0.004 / thickness) * 0.7) * centerFade + bell(rimSd + uUnit * 0.035, uUnit * 0.003 * thickness) * 0.5;
  vec3 lowerRelief = (
    vec3(0.03, 0.32, 1.0) * bell(sd + uUnit * 0.038, uUnit * 0.022 + aa * 0.2) * 0.55 +
    vec3(0.22, 0.62, 1.0) * bell(sd + uUnit * 0.027, uUnit * 0.012 + aa * 0.1) * 0.7 +
    vec3(0.75, 0.97, 1.0) * filaments * 1.35
  ) * drift * lowerRight * glass * uHighlights * uRelief * (1.0 - 0.85 * ease(0.6, 1.0, t)) * (1.0 - settle);
  lowerRelief *= 1.0 - pores.x * 0.22;
  lowerRelief += vec3(0.45, 0.85, 1.0) * pores.y * 0.10 * lowerRight * glass * uHighlights * uRelief * (1.0 - settle);
  // With focus at 0 the inner wall is drawn whole. Raising it keeps the wall on a
  // pale plate to its strongly lit segments and its upper-left and lower-right
  // arcs, since there its weak light clips to white and its shadow would
  // otherwise outline the full contour.
  float wallLit = clamp(key * key * 0.8 * upperSliver + lowerRight * lowerRight * 0.75 * lowerSliver, 0.0, 1.0);
  float wallGate = mix(1.0, max(ease(0.2, 0.7, wallLit), wallCorner), uPageLight * uInnerWallFocus);
  color *= 1.0 - wallShadow * wallGate * uRelief * 0.12 * (1.0 - ink.a);
  color += backFace + lowerRelief + insetLight * wallGate * glass * uHighlights * uRelief * (1.0 - ink.a) * mix(rimVisibility, 0.9, key);
  alpha = max(alpha, max(lowerRelief.r, max(lowerRelief.g, lowerRelief.b)));
  float rimLight = rim * (0.07 + key * 0.55) + inner * (0.025 + key * 0.16) + inner2 * 0.025;
  // Micro-bubbles along the lit edges, strongest where the key and the lower fill land.
  float speckSize = max(uUnit * 0.0042, 0.8 / uDpr);
  float bubbles = driftingSpecks(arc, rimLineSd + uUnit * 0.002, speckSize, 0.0, t) * 0.9;
  bubbles += specks(arc, innerSd + uUnit * 0.012, speckSize * 0.8, 97.0) * 0.6 * centerFade;
  bubbles += specks(arc, insetSd, speckSize * 0.9, 191.0) * 0.5 * centerFade;
  rimLight += bubbles * (0.04 + key * 0.5 + lowerRight * 0.45);
  rimLight = rimLight * (1.0 - pores.x * 0.35) + pores.y * (key * 0.16 + lowerRight * 0.12);
  vec3 spectralRim = vec3(0.0);
  vec3 spectralWeights = vec3(0.0);
  for (int i = 0; i < BANDS; i++) {
    float s = float(i) / float(BANDS - 1);
    vec3 w = spectrum(s);
    spectralRim += w * bell(rimSd + (s - 0.5) * uUnit * 0.011 * uDispersion + uUnit * 0.003, uUnit * 0.002 * thickness);
    spectralWeights += w;
  }
  spectralRim /= spectralWeights;
  vec3 reflection = (vec3(0.6, 0.76, 0.9) * rimLight * 1.15 + spectralRim * (0.02 + ink.a * 0.32)) * uHighlights * glass * mix(rimVisibility, 1.2, key);
  float sphericalRim = (
    bell(sd + uUnit * lensScale * 0.008, uUnit * lensScale * 0.009) * 0.60 +
    bell(insetSd, uUnit * lensScale * 0.008) * 0.40
  ) * (0.25 + 0.75 * abs(outward.y)) * (1.0 - ease(0.235, 0.34, t));
  reflection += vec3(0.65, 0.80, 0.90) * sphericalRim * 1.4 * uHighlights * glass;
  float cyanKey = pow(max(0.0, -outward.x), 8.0) * (1.0 - ease(0.235, 0.34, t));
  float cyanLip = bell(sd + uUnit * lensScale * 0.020, uUnit * lensScale * 0.009);
  cyanLip += bell(insetSd, uUnit * lensScale * 0.005) * 0.35;
  reflection += vec3(0.015, 0.68, 1.0) * cyanLip * cyanKey * glass * uHighlights * 0.85;
  // The young drop is full of scattered light: a milky glow behind the artwork.
  float youth = 1.0 - ease(0.25, 0.37, t);
  reflection += vec3(0.78, 0.84, 0.9) * youth * 0.07 * (0.5 + 0.5 * radius) * (1.0 - ink.a) * glass;
  vec3 film = mix(vec3(0.32, 0.0, 0.20), vec3(0.32, 0.08, 0.02), ease(0.75, 1.12, t)) * bell(sd + uUnit * 0.001, uUnit * 0.002) * ink.a * glass * uHighlights;
  color += reflection + film;
  alpha = max(alpha, max(reflection.r, max(reflection.g, reflection.b)));
  vec4 result = vec4(color * mask, alpha * mask);

  // Reflections outside the body are faint glass echoes, not solid colored outlines.
  float outer = bell(rimSd - uUnit * 0.012, uUnit * 0.0028 * thickness) * (0.04 + key * 0.2) * (0.5 + contourNoise(arc / grainScale + 131.0));
  outer += specks(arc, rimSd - uUnit * 0.012, speckSize, 277.0) * (0.03 + key * 0.3 + lowerRight * 0.25);
  // A single wave leaves the rim as the plate forms, stays close to it and fades.
  float waveAge = ease(0.36, 1.1, t);
  float wave = bell(sd - uUnit * (0.014 + 0.03 * waveAge), uUnit * 0.004 + aa * 0.3) * 0.05 * ease(0.34, 0.42, t) * (1.0 - waveAge);
  // The echo is lit through the plate, so it can carry the plate's hue and, on a
  // dark page, stay quieter than the rim it echoes.
  vec3 echoTint = mix(vec3(0.43, 0.62, 0.79), uTile + (1.0 - uTile) * 0.4, 0.5 * uEchoTint);
  float echoLevel = mix(1.0, mix(0.6, 1.0, uPageLight), uEchoTint);
  // The echo line runs around all four sides. The wave stays faint on the left
  // and right, where a full ring would read as streaks beside the glass.
  float waveSides = mix(1.0, 0.10, ease(0.25, 0.80, abs(outward.x)));
  vec3 ghost = (echoTint + ink.rgb * 0.6) * (outer + wave * waveSides) * glass * uHighlights * rimVisibility * echoLevel;
  float exterior = max(ghost.r, max(ghost.g, ghost.b)) * 1.8;
  result.rgb += exteriorColor(ghost * 1.8, exterior);
  result.a = max(result.a, exterior);
  // Resolve directly to the source, retaining its full size after the glass fades.
  return mix(result * shown, source, settle);
}

// The second drop is a radial lens with spherical aberration. Its core magnifies the
// wordmark (inverting it while the drop is tall), so between center and edge the image
// runs through focus and floods the drop; across its rim a thin ring of the image is
// stretched outward, and ripples crossing the rim repeat that ring in bands.
vec4 wordmarkLens(vec2 p) {
  float t = uTime;
  if (uWordmarkEnabled < 0.5) return vec4(0.0);
  if (t < 1.46) return vec4(0.0);
  if (t >= 3.3) return imageAt(uText, p, uTextBox);
  float radius = max(uDrop.x, 1.0);
  float r = length(p);
  if (r > radius + uUnit * 0.6) return vec4(0.0);
  vec2 outward = p / max(r, 0.001);
  float q = r / radius;
  float aa = 1.0 / uDpr;
  float edge = radius - r;
  float mask = ease(-aa, aa, edge);
  float young = 1.0 - ease(1.72, 2.02, t);

  float core = min(uDrop.y, radius);
  float coreQ = r / max(core, 1.0);
  float edgeLanding = core / max(uDropLens.x, 0.01);
  float center = uDrop.w;
  float landing = r < core
    ? edgeLanding * coreQ * (center + (1.0 - center) * pow(coreQ, uDropLens.y))
    : edgeLanding + (r - core) * uDrop.z;
  float rimZone = ease(core * 0.9, core, r);
  float k = 2.0 * PI / max(uDropLens.w, 1.0);
  landing += uDropLens.z * sin(k * r - uDropWave.x) * ease(0.0, uDropLens.w, r) * mix(uDropWave.y, 1.0, rimZone);
  vec2 bend = outward * (landing - r);
  float spread = uDropWave.z * uDispersion * (0.15 + 0.85 * rimZone);

  vec3 color = vec3(0.0);
  vec3 weights = vec3(0.0);
  float alpha = 0.0;
  float opacity = ease(1.46, 1.49, t);
  for (int i = 0; i < BANDS; i++) {
    float s = float(i) / float(BANDS - 1);
    vec2 source = p + bend * (1.0 + spread * (s - 0.5));
    vec4 ink = imageAt(uText, source, uTextBox);
    vec3 w = spectrum(s);
    color += ink.rgb * w;
    alpha += ink.a * (w.r + w.g + w.b);
    weights += w;
  }
  color /= weights;
  alpha /= weights.r + weights.g + weights.b;
  color *= 1.0 + uCaustics * bell(edge, uUnit * 0.06) * 0.15;
  color *= mask;
  alpha *= mask;
  // A fresh drop is full of scattered light: overexposed ink, a milky body and a cool
  // spill around it, all fading as it flattens.
  float fresh = 1.0 - ease(1.62, 1.95, t);
  color = min(color * (1.0 + 0.6 * fresh), vec3(1.0));
  float milk = mask * fresh * 0.30 * (0.6 + 0.4 * q) * uCaustics;
  color += vec3(0.75, 0.82, 0.9) * milk * (1.0 - alpha);
  float spill = exp(-max(r - radius, 0.0) / (uUnit * 0.17)) * (1.0 - mask) * fresh * 0.12;
  // As it spreads, the drop keeps a faint blue haze that dies with the waves.
  spill += exp(-max(r - radius, 0.0) / (uUnit * 0.4)) * (1.0 - fresh) * 0.035 * exp(-max(t - 1.95, 0.0) / 0.45) * (1.0 - ease(2.8, 3.1, t));
  color += vec3(0.32, 0.6, 1.0) * spill;
  alpha = max(alpha, max(milk, spill));
  vec3 sphereNormal = normalize(vec3(p / radius, sqrt(max(0.005, 1.0 - q * q))));
  vec3 reflected = reflect(vec3(0.0, 0.0, -1.0), sphereNormal);
  float softbox = bell(reflected.x + 0.3, 0.2) * bell(reflected.y - 0.55, 0.15);
  float smallLight = bell(reflected.x - 0.25, 0.14) * bell(reflected.y - 0.65, 0.08);
  float broadLight = bell(reflected.x + 0.35, 0.65) * bell(reflected.y - 0.6, 0.45);
  float surface = (softbox * 0.8 + smallLight * 0.6 + broadLight * 0.22) * young * uHighlights * mask;
  color += vec3(0.85, 0.95, 1.0) * surface;
  alpha = max(alpha, surface);

  float key = pow(0.5 + 0.5 * dot(outward, normalize(vec2(-0.6, 0.8))), 7.0);
  float rings = 0.0;
  for (int i = 0; i < 4; i++) {
    float j = float(i);
    float ringRadius = radius + (j - 1.0) * uUnit * 0.022 * (1.0 + 0.55 * ease(1.8, 3.1, t));
    rings += bell(r - ringRadius, uUnit * (0.003 + j * 0.001)) * (0.11 / (1.0 + j));
  }
  float age = max(0.0, t - 1.46);
  float fade = exp(-age / max(uDecay, 0.1)) * (1.0 - ease(2.65, 3.3, t));
  // Only the drop's own nested rims are lit; no broad glow or crest travels out
  // beyond it.
  float sideLight = pow(abs(outward.x), 10.0) * mix(1.0, 0.72, step(0.0, p.x));
  vec3 reflection = vec3(0.4, 0.62, 0.79) * rings * (0.3 + key * 2.0 + sideLight * 1.8) * fade * uHighlights;
  color += reflection;
  alpha = max(alpha, max(reflection.r, max(reflection.g, reflection.b)));
  return vec4(color, alpha) * opacity;
}

void main() {
  vec2 p = (gl_FragCoord.xy - uResolution * 0.5) / uDpr;
  vec4 icon = iconLens(p);
  vec4 wordmark = wordmarkLens(p);
  vec4 result = wordmark + icon * (1.0 - wordmark.a);
  // RGB and alpha use the same coverage; preserve saturated spectral fringes when
  // compositing onto transparent or colored backgrounds.
  result.a = clamp(max(result.a, max(result.r, max(result.g, result.b))), 0.0, 1.0);
  float dither = (fract(sin(dot(gl_FragCoord.xy, vec2(12.9898, 78.233))) * 43758.5453) - 0.5) / 255.0;
  outColor = vec4(clamp(result.rgb + dither * result.a, vec3(0.0), vec3(result.a)), result.a);
}
`,pe=`#version 300 es
precision highp float;
uniform sampler2D uScene;
uniform vec2 uResolution;
uniform float uDpr;
uniform float uUnit;
uniform float uSettle;
uniform float uBloom;
uniform float uTime;
uniform float uFinish;
uniform float uPageLight;
out vec4 outColor;

// Filter premultiplied color and coverage together. The footprint is in CSS
// pixels, so the glass has the same optical softness on normal and retina screens.
vec4 softenedWaves(vec2 uv, float lod) {
  vec2 d = vec2(uDpr * 0.90) / uResolution;
  vec4 blurred = textureLod(uScene, uv, lod) * 0.25;
  blurred += textureLod(uScene, uv + vec2(d.x, 0.0), lod) * 0.125;
  blurred += textureLod(uScene, uv - vec2(d.x, 0.0), lod) * 0.125;
  blurred += textureLod(uScene, uv + vec2(0.0, d.y), lod) * 0.125;
  blurred += textureLod(uScene, uv - vec2(0.0, d.y), lod) * 0.125;
  blurred += textureLod(uScene, uv + d, lod) * 0.0625;
  blurred += textureLod(uScene, uv - d, lod) * 0.0625;
  blurred += textureLod(uScene, uv + vec2(d.x, -d.y), lod) * 0.0625;
  blurred += textureLod(uScene, uv + vec2(-d.x, d.y), lod) * 0.0625;
  return blurred;
}

void main() {
  vec2 uv = gl_FragCoord.xy / uResolution;
  vec4 base = textureLod(uScene, uv, 0.0);
  float offset = log2(max(uDpr, 0.5));
  // Only the exterior liquid is softened. The artwork and its final resting
  // silhouette retain their native sharpness and original coverage.
  float wavePhase = smoothstep(0.29, 0.41, uTime) * (1.0 - smoothstep(1.25, 1.50, uTime));
  float waveMask = 0.0;
  if (wavePhase > 0.001) {
    float enter = smoothstep(0.025, 0.16, uTime);
    float expand = enter * (0.64 + 0.41 * (1.0 - exp(-max(uTime - 0.16, 0.0) * 5.8)));
    float collapse = 1.0 - smoothstep(1.33, 1.52, uTime);
    float lensScale = mix(expand * mix(0.48, 1.0, collapse), 1.0, smoothstep(0.0, 1.0, uSettle));
    float halfSize = max(0.001, uUnit * lensScale * 0.5);
    float shape = 2.0 + 3.0 * smoothstep(0.29, 0.36, uTime);
    vec2 p = abs((gl_FragCoord.xy - uResolution * 0.5) / uDpr) / halfSize;
    float radius = pow(pow(p.x, shape) + pow(p.y, shape), 1.0 / shape);
    float distance = (radius - 1.0) * halfSize;
    waveMask = smoothstep(0.0, max(0.75, uUnit * 0.004), distance) * wavePhase;
    if (waveMask > 0.001) {
      base = mix(base, softenedWaves(uv, max(0.0, offset + 0.15)), waveMask * 0.94);
    }
  }
  vec3 diffused = textureLod(uScene, uv, offset + 2.5).rgb * 0.50;
  diffused += textureLod(uScene, uv, offset + 4.1).rgb * 0.32;
  diffused += textureLod(uScene, uv, offset + 5.4).rgb * 0.18;
  float light = max(base.r, max(base.g, base.b));
  // Bright ink retains its calibrated color; light diffuses into its surroundings.
  float effect = 1.0 - smoothstep(0.0, 1.0, uFinish);
  // Bloom is light spilling onto a dark page. A pale page already holds that
  // light, and adding it where the plate thins out reads as a flash.
  vec3 glow = diffused * uBloom * 0.20 * (1.0 - min(1.0, light * 1.2)) * effect * (1.0 - uPageLight);
  float alpha = clamp(max(base.a, max(glow.r, max(glow.g, glow.b))), 0.0, 1.0);
  float grain = fract(sin(dot(gl_FragCoord.xy + floor(uTime * 24.0), vec2(12.9898, 78.233))) * 43758.5453) - 0.5;
  vec3 color = base.rgb + glow + grain * 0.009 * base.a * clamp(light * 3.0 + 0.05, 0.05, 1.0) * effect * (1.0 - waveMask * 0.85);
  outColor = vec4(clamp(color, vec3(0.0), vec3(alpha)), alpha);
}
`});function z(t,a){var v,U;if(a<=t[0][0])return t[0][1];let i=t[t.length-1];if(a>=i[0])return i[1];let e=0;for(;a>t[e+1][0];)e++;let[l,g]=t[e],[d,u]=t[e+1],[s,p]=(v=t[e-1])!=null?v:[l-(d-l),g],[o,h]=(U=t[e+2])!=null?U:[d+(d-l),u],c=d-l,y=(u-p)/(d-s)*c,R=(h-g)/(o-l)*c,b=(a-l)/c,k=b*b,x=k*b;return(2*x-3*k+1)*g+(x-2*k+b)*y+(-2*x+3*k)*u+(x-k)*R}function ye(t){let a=(e,l,g,d)=>Number.isFinite(e)?Math.min(d,Math.max(g,e)):l,i=ie;return{...t,ending:t.ending==="wordmark"?"wordmark":"logo",theme:t.theme==="light"?"light":"dark",logoSize:a(t.logoSize,i.logoSize,24,1024),logoScale:a(t.logoScale,i.logoScale,.1,1),finalLogoScale:a(t.finalLogoScale,i.finalLogoScale,.1,1),fontSize:a(t.fontSize,i.fontSize,8,400),fontWeight:a(t.fontWeight,i.fontWeight,100,1e3),letterSpacing:a(t.letterSpacing,i.letterSpacing,-.3,1),markGap:a(t.markGap,i.markGap,0,2),depth:a(t.depth,i.depth,0,6),dispersion:a(t.dispersion,i.dispersion,0,4),relief:a(t.relief,i.relief,0,3),caustics:a(t.caustics,i.caustics,0,4),highlights:a(t.highlights,i.highlights,0,4),bloom:a(t.bloom,i.bloom,0,2),dropSize:a(t.dropSize,i.dropSize,.05,1.5),dropStrength:a(t.dropStrength,i.dropStrength,0,4),echoTint:a(t.echoTint,i.echoTint,0,1),logoRelief:a(t.logoRelief,i.logoRelief,0,1),innerWallFocus:a(t.innerWallFocus,i.innerWallFocus,0,1),decay:a(t.decay,i.decay,.1,10),speed:a(t.speed,i.speed,.1,4),loopDelay:a(t.loopDelay,i.loopDelay,0,30),maxDpr:a(t.maxDpr,i.maxDpr,.5,4)}}function xe(t){return new Promise(a=>{if(!t)return a(null);let i=new Image;i.crossOrigin="anonymous",i.decoding="async",i.onload=()=>a(i),i.onerror=()=>a(null),i.src=t})}function Te(t,a,i,e,l,g,d){if(d==="original"){t.drawImage(a,i,e,l,g);return}let u=document.createElement("canvas");u.width=Math.max(1,Math.ceil(l)),u.height=Math.max(1,Math.ceil(g));let s=u.getContext("2d");s.drawImage(a,0,0,u.width,u.height),s.globalCompositeOperation="source-in",s.fillStyle=d,s.fillRect(0,0,u.width,u.height),t.drawImage(u,i,e,l,g)}function ke(t){let a=t.naturalWidth||t.width||1,i=t.naturalHeight||t.height||1;return{width:a,height:i}}function Le(t,a,i){if(i<=0)return;let e=t.getContext("2d"),{width:l,height:g}=t,d=e.getImageData(0,0,l,g),u=d.data,s=new Float32Array(l*g);for(let o=0;o<s.length;o++)s[o]=u[o*4+3]>127?1e6:0;let p=Math.SQRT2;for(let o=1;o<g-1;o++)for(let h=1;h<l-1;h++){let c=o*l+h;s[c]=Math.min(s[c],s[c-1]+1,s[c-l]+1,s[c-l-1]+p,s[c-l+1]+p)}for(let o=g-2;o>0;o--)for(let h=l-2;h>0;h--){let c=o*l+h;s[c]=Math.min(s[c],s[c+1]+1,s[c+l]+1,s[c+l-1]+p,s[c+l+1]+p)}for(let o=0;o<s.length;o++){let h=Math.max(0,1-s[o]/a);s[o]=Math.sqrt(Math.max(0,1-h*h))*a*.4}for(let o=1;o<g-1;o++)for(let h=1;h<l-1;h++){let c=o*l+h;if(!u[c*4+3])continue;let y=(s[c-1]-s[c+1])*.5,R=(s[c-l]-s[c+l])*.5,x=1+((.74+Math.max(0,(-y*.45-R*.6+.8)/Math.hypot(y,R,1))*.26)/(.74+.8*.26)-1)*i;for(let v=0;v<3;v++)u[c*4+v]*=x}e.putImageData(d,0,0)}function Oe(t,a,i){let e=Math.min(2048,ae(a.logoSize*i*2)),l=document.createElement("canvas");l.width=l.height=e;let g=l.getContext("2d");if(t){let{width:d,height:u}=ke(t),s=e*a.logoScale/Math.max(d,u),p=d*s,o=u*s;Te(g,t,(e-p)/2,(e-o)/2,p,o,a.logoColor)}return t&&a.logoColor!=="original"&&Le(l,l.width*.03,a.logoRelief),{canvas:l,box:[a.logoSize,a.logoSize]}}function oe(t){return`${t.fontWeight} ${t.fontSize}px ${t.fontFamily}`}function Xe(t,a,i){let e=document.createElement("canvas").getContext("2d");e.font=oe(a),e.fontStretch=a.fontStretch;let l=a.letterSpacing*a.fontSize;e.letterSpacing=`${l}px`;let g=Math.max(0,e.measureText(a.text).width),d=e.measureText(a.text||"x"),u=d.actualBoundingBoxAscent||a.fontSize*.72,s=d.actualBoundingBoxDescent||a.fontSize*.2,p=e.measureText("x").actualBoundingBoxAscent||a.fontSize*.52,o=0,h=0;if(t){let{width:A,height:r}=ke(t);h=Math.max(u,p*1.3),o=A/r*h}let c=t&&a.text.length?a.markGap*a.fontSize:0,y=o+c+g,R=a.fontSize*.5,b=[y+R*2,a.fontSize*2],k=Math.min(i*2,4096/b[0],4096/b[1]),x=document.createElement("canvas");x.width=Math.min(4096,ae(b[0]*k)),x.height=Math.min(4096,ae(b[1]*k));let v=x.getContext("2d");v.scale(x.width/b[0],x.height/b[1]);let U=b[1]/2+(u-s)/2,q=R;if(t){let A=a.logoColor==="original"?"original":a.textColor;Te(v,t,q,U-h,o,h,A),q+=o+c}return v.font=oe(a),v.fontStretch=a.fontStretch,v.fillStyle=a.textColor,v.textBaseline="alphabetic",v.letterSpacing=`${l}px`,v.textAlign="left",v.fillText(a.text,q,U),a.logoColor!=="original"&&Le(x,a.fontSize*.04*x.height/b[1],a.logoRelief),{canvas:x,box:b,contentWidth:y}}function we(t){var l,g;let a=document.createElement("canvas").getContext("2d");a.fillStyle="#000",a.fillStyle=t;let i=String(a.fillStyle);if(i.startsWith("#")){let d=parseInt(i.slice(1,7),16);return[(d>>16)/255,(d>>8&255)/255,(d&255)/255]}let e=(g=(l=i.match(/[\d.]+/g))==null?void 0:l.map(Number))!=null?g:[0,0,0];return[e[0]/255,e[1]/255,e[2]/255]}function Re(t,a,i){var ue,fe;let e=t.getContext("webgl2",{premultipliedAlpha:!0,alpha:!0,antialias:!1});if(!e)return null;let l=(n,m)=>{let f=e.createShader(n);if(e.shaderSource(f,m),e.compileShader(f),!e.getShaderParameter(f,e.COMPILE_STATUS)){let w=e.getShaderInfoLog(f);throw e.deleteShader(f),new Error(w!=null?w:"Liquid Glass Logo shader failed to compile.")}return f},g=n=>{let m=e.createProgram(),f=l(e.VERTEX_SHADER,ge),w=l(e.FRAGMENT_SHADER,n);if(e.attachShader(m,f),e.attachShader(m,w),e.bindAttribLocation(m,0,"aPosition"),e.linkProgram(m),e.deleteShader(f),e.deleteShader(w),!e.getProgramParameter(m,e.LINK_STATUS)){let E=e.getProgramInfoLog(m);throw e.deleteProgram(m),new Error(E!=null?E:"Liquid Glass Logo program failed to link.")}return m},d=g(me),u=g(pe),s=Object.fromEntries(["uScene","uResolution","uDpr","uUnit","uSettle","uBloom","uTime","uFinish","uPageLight"].map(n=>[n,e.getUniformLocation(u,n)])),p=new Map,o=n=>(p.has(n)||p.set(n,e.getUniformLocation(d,n)),p.get(n)),h=e.createVertexArray();e.bindVertexArray(h);let c=e.createBuffer();e.bindBuffer(e.ARRAY_BUFFER,c),e.bufferData(e.ARRAY_BUFFER,new Float32Array([-1,-1,3,-1,-1,3]),e.STATIC_DRAW),e.enableVertexAttribArray(0),e.vertexAttribPointer(0,2,e.FLOAT,!1,0,0);let y=()=>{let n=e.createTexture();return e.bindTexture(e.TEXTURE_2D,n),e.texImage2D(e.TEXTURE_2D,0,e.RGBA,1,1,0,e.RGBA,e.UNSIGNED_BYTE,new Uint8Array(4)),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR_MIPMAP_LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.CLAMP_TO_EDGE),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.CLAMP_TO_EDGE),n},R=y(),b=y(),k=y(),x=e.createFramebuffer();e.bindFramebuffer(e.FRAMEBUFFER,x),e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,k,0),e.bindFramebuffer(e.FRAMEBUFFER,null);let v=0,U=0,q=()=>{v===t.width&&U===t.height||(v=t.width,U=t.height,e.activeTexture(e.TEXTURE0),e.bindTexture(e.TEXTURE_2D,k),e.texImage2D(e.TEXTURE_2D,0,e.RGBA8,v,U,0,e.RGBA,e.UNSIGNED_BYTE,null))},A=(n,m)=>{e.activeTexture(e.TEXTURE0),e.bindTexture(e.TEXTURE_2D,n),e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,!0),e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,!0),e.texImage2D(e.TEXTURE_2D,0,e.RGBA,e.RGBA,e.UNSIGNED_BYTE,m),e.generateMipmap(e.TEXTURE_2D)},r=a,F=1,N=1,$=1,Z=[1,1],O=0,X=!1,V=!1,re="",le=0,P=null,C=0,L=0,G=!a.paused,J=!0,j=0,T=(ue=window.matchMedia)==null?void 0:ue.call(window,"(prefers-reduced-motion: reduce)"),Ee=()=>Math.min(1,N/Math.max(r.logoSize*1.9,r.ending==="wordmark"?O*1.22:0),$/(r.logoSize*1.5)),B=()=>{if(!X||V)return;let n=Ee();q(),e.bindFramebuffer(e.FRAMEBUFFER,x),e.viewport(0,0,t.width,t.height),e.useProgram(d),e.bindVertexArray(h),[R,b].forEach((Fe,Pe)=>{e.activeTexture(e.TEXTURE0+Pe),e.bindTexture(e.TEXTURE_2D,Fe)}),e.uniform1i(o("uLogo"),0),e.uniform1i(o("uText"),1),e.uniform2f(o("uResolution"),t.width,t.height),e.uniform1f(o("uDpr"),t.width/N),e.uniform1f(o("uUnit"),r.logoSize*n),e.uniform2f(o("uLogoBox"),r.logoSize*n,r.logoSize*n),e.uniform2f(o("uTextBox"),Z[0]*n,Z[1]*n),e.uniform1f(o("uTextWidth"),O*n);let m=r.ending==="logo"?H:Q,f=T!=null&&T.matches?m:C,w=r.ending==="logo"?Math.min(H,f):f;e.uniform1f(o("uTime"),w),e.uniform1f(o("uWordmarkEnabled"),r.ending==="wordmark"?1:0);let E=r.ending==="logo"?Math.max(0,Math.min(1,(f-1.16)/(1.4-1.16))):0,I=r.logoSize*n,K=Math.max(O*n/2,I*.3),S=w,_=1-D(2.85,3.02,S);e.uniform4f(o("uDrop"),K*z(qe,S),K*z(Ne,S),Math.max(.02,Math.min(1,z(Be,S))),1+(z(_e,S)-1)*r.dropStrength),e.uniform4f(o("uDropLens"),1+(z(He,S)-1)*r.dropStrength,2+4*D(1.74,1.84,S),I*(.009*Math.exp(-Math.max(S-1.46,0)/.5)*(1-D(1.85,1.95,S))+.012*D(2.2,2.4,S))*_,I*(.07+(.03-.07)*D(1.9,2.4,S))),e.uniform4f(o("uDropWave"),(S-1.45)*42,1-D(1.85,2,S),2*(.12+1.6*D(1.86,2,S)-.9*D(2.25,2.5,S))*_,0);let W=D(1.13,1.28,f),Y=r.ending==="logo"&&f>1.13?z(be,1.13)*(1-W)+r.finalLogoScale*W:z(be,w);e.uniform1f(o("uArtScale"),Y),e.uniform1f(o("uSettle"),E),e.uniform3fv(o("uTile"),we(r.tileColor));let[Ce,Me,ze]=we(r.background),Ae=.299*Ce+.587*Me+.114*ze,he=Math.min(1,Math.max(0,(Ae-.35)/.4));e.uniform1f(o("uPageLight"),he),e.uniform1f(o("uTileEnabled"),r.tile?1:0),e.uniform1f(o("uDepth"),r.depth),e.uniform1f(o("uDispersion"),r.dispersion),e.uniform1f(o("uRelief"),r.relief),e.uniform1f(o("uCaustics"),r.caustics),e.uniform1f(o("uHighlights"),r.highlights),e.uniform1f(o("uEchoTint"),r.echoTint),e.uniform1f(o("uInnerWallFocus"),r.innerWallFocus),e.uniform1f(o("uDropSize"),r.dropSize),e.uniform1f(o("uDropStrength"),r.dropStrength),e.uniform1f(o("uDecay"),r.decay),e.drawArrays(e.TRIANGLES,0,3),e.bindFramebuffer(e.FRAMEBUFFER,null),e.useProgram(u),e.activeTexture(e.TEXTURE0),e.bindTexture(e.TEXTURE_2D,k),e.generateMipmap(e.TEXTURE_2D),e.uniform1i(s.uScene,0),e.uniform2f(s.uResolution,t.width,t.height),e.uniform1f(s.uDpr,t.width/N),e.uniform1f(s.uUnit,I),e.uniform1f(s.uSettle,E),e.uniform1f(s.uBloom,r.bloom),e.uniform1f(s.uPageLight,he),e.uniform1f(s.uTime,w),e.uniform1f(s.uFinish,r.ending==="logo"?Math.max(0,Math.min(1,(f-1.05)/(H-1.05))):Math.max(0,Math.min(1,(f-2.8)/(Q-2.8)))),e.drawArrays(e.TRIANGLES,0,3)},ee=async()=>{var Y;let n=JSON.stringify([r.logo,r.mark,r.text,r.logoSize,r.logoScale,r.fontSize,r.fontFamily,r.fontWeight,r.fontStretch,r.letterSpacing,r.markGap,r.logoColor,r.logoRelief,r.textColor,F]);if(n===re)return;re=n;let m=++le,f={...r},w=f.mark==="logo"?f.logo:f.mark,[E,I]=await Promise.all([xe(f.logo),w===f.logo?null:xe(w),(Y=document.fonts)==null?void 0:Y.load(oe(f),f.text||"x").catch(()=>{})]);if(V||m!==le)return;let K=w===f.logo?E:I,S=JSON.stringify([f.logo,f.logoSize,f.logoScale,f.logoColor,f.logoRelief,F]),_=(P==null?void 0:P.key)===S?P.raster:Oe(E,f,F);P={key:S,raster:_};let W=Xe(w?K:null,f,F);A(R,_.canvas),A(b,W.canvas),Z=W.box,O=W.contentWidth,X||(X=!0,L=0,i==null||i()),B(),M()},De=n=>{j=0;let m=L?Math.min(.05,(n-L)/1e3):0;L=n;let f=G&&J&&!(T!=null&&T.matches)&&X;if(f){C+=m*r.speed;let w=(r.ending==="logo"?H:Q)+r.loopDelay;r.loop&&C>=w&&(C%=w)}B(),f&&(r.loop||C<(r.ending==="logo"?H:Q))?M():L=0};function M(){!j&&!V&&(j=requestAnimationFrame(De))}let te=()=>{let n=getComputedStyle(t);N=Math.max(1,Number.parseFloat(n.width)||t.clientWidth),$=Math.max(1,Number.parseFloat(n.height)||t.clientHeight);let m=Math.min(window.devicePixelRatio||1,r.maxDpr);t.width=Math.max(1,Math.round(N*m)),t.height=Math.max(1,Math.round($*m)),m!==F&&(F=m,ee()),B(),M()},se=new ResizeObserver(te);se.observe(t);let ne=new IntersectionObserver(([n])=>{var m;J=(m=n==null?void 0:n.isIntersecting)!=null?m:!0,L=0,J&&M()});ne.observe(t);let ce=()=>{L=0,M()};return(fe=T==null?void 0:T.addEventListener)==null||fe.call(T,"change",ce),te(),ee(),{update(n){let m=G;r=n,G=!n.paused,!m&&G&&(L=0),te(),ee()},replay(){C=0,L=0,B(),M()},seek(n){C=Number.isFinite(n)?Math.max(0,Math.min(3600,n)):0,L=0,B()},pause(){G=!1,L=0},play(){G=!0,L=0,M()},dispose(){var n;V=!0,P=null,cancelAnimationFrame(j),se.disconnect(),ne.disconnect(),(n=T==null?void 0:T.removeEventListener)==null||n.call(T,"change",ce),e.deleteTexture(R),e.deleteTexture(b),e.deleteTexture(k),e.deleteFramebuffer(x),e.deleteBuffer(c),e.deleteVertexArray(h),e.deleteProgram(d),e.deleteProgram(u)}}}var Ie,We,ie,Q,H,be,qe,Ne,Be,_e,He,D,Se,ae,Ue=de(()=>{ve();Ie=`data:image/svg+xml;utf8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96 104"><path fill="#fff" d="M35 24c0-2.6 1.7-4.8 4.2-5.5L79.6 7.6C82.6 6.8 85 9 85 12.1V64c0 8.9-7.3 17-16.5 19.2C59.3 85.4 52 81 52 73.2c0-9 7.5-16.9 16.7-19.1 3.3-.8 6.3-.9 8.3-.2V28.8L43 38.1V77c0 8.9-7.3 17-16.5 19.2C17.3 98.4 10 94 10 86.2c0-9 7.5-16.9 16.7-19.1 3.3-.8 6.3-.9 8.3-.2V24Z"/></svg>')}`,We=`data:image/svg+xml;utf8,${encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="#fff"><path d="M12.152 6.896c-.948 0-2.415-1.078-3.96-1.04-2.04.027-3.91 1.183-4.961 3.014-2.117 3.675-.546 9.103 1.519 12.09 1.013 1.454 2.208 3.09 3.792 3.039 1.52-.065 2.09-.987 3.935-.987 1.831 0 2.35.987 3.96.948 1.637-.026 2.676-1.48 3.676-2.948 1.156-1.688 1.636-3.325 1.662-3.415-.039-.013-3.182-1.221-3.22-4.857-.026-3.04 2.48-4.494 2.597-4.559-1.429-2.09-3.623-2.324-4.39-2.376-2-.156-3.675 1.09-4.61 1.09zM15.53 3.83c.843-1.012 1.4-2.427 1.245-3.83-1.207.052-2.662.805-3.532 1.818-.78.896-1.454 2.338-1.273 3.714 1.338.104 2.715-.688 3.559-1.701"/></svg>')}`,ie={logo:Ie,mark:We,text:"music",ending:"logo",logoSize:256,logoScale:.72,finalLogoScale:1,tile:!0,fontSize:64,fontFamily:'system-ui, -apple-system, "Helvetica Neue", Arial, sans-serif',fontWeight:850,fontStretch:"expanded",letterSpacing:-.01,markGap:.12,theme:"dark",logoColor:"#ffffff",logoRelief:1,textColor:"#e2e6ee",tileColor:"#060c18",background:"#000000",depth:1.2,dispersion:1,relief:1,caustics:1,highlights:1,bloom:.55,dropSize:.32,dropStrength:1,echoTint:.5,innerWallFocus:0,decay:1.4,speed:1,loop:!1,loopDelay:1.6,paused:!1,maxDpr:2},Q=3.3,H=1.8;be=[[.12,1.4],[.33,1.45],[.46,1.44],[.63,1.33],[.79,1.24],[.96,1.2],[1.13,1.11],[1.25,1],[1.335,.865],[1.376,.81],[1.418,.735],[1.46,.41]],qe=[[1.46,.32],[1.55,.36],[1.67,.49],[1.75,.52],[1.84,.56],[1.92,.68],[2,.88],[2.15,.95],[2.4,1.06],[2.95,1.3]],Ne=[[1.46,1.5],[1.84,1.5],[1.92,.55],[2,.6],[2.09,.68],[2.17,.78],[2.3,.85],[2.5,.9],[2.75,.93],[2.95,.97],[3.02,1.03]],Be=[[1.46,.3],[1.84,.3],[2,.25],[2.1,.2],[2.2,.2],[2.4,.25],[2.7,.3],[2.85,.45],[2.95,.8],[3.02,1]],_e=[[1.46,-.6],[1.6,-.5],[1.75,-.3],[1.8,.4],[1.84,1]],He=[[1.46,1.5],[1.6,1.5],[1.75,2.2],[1.84,1.4],[1.92,1.2],[2,1.05],[2.1,1]],D=(t,a,i)=>{let e=Math.min(1,Math.max(0,(i-t)/(a-t)));return e*e*(3-2*e)},Se={dark:{logoColor:"#ffffff",textColor:"#e2e6ee",tileColor:"#060c18",background:"#000000"},light:{logoColor:"#09111b",textColor:"#09111b",tileColor:"#e4e6ea",background:"#e2e2e5"}};ae=t=>2**Math.ceil(Math.log2(Math.max(2,t)))});var Ve=Ge(()=>{Ue();(function(){let t=window.PP_INTRO,a=document.documentElement,i=()=>{a.classList.remove("pp-intro")};if(!t)return i();let e=!1;try{e=!!sessionStorage.getItem("pp-intro")}catch{}let l=window.matchMedia&&window.matchMedia("(prefers-reduced-motion: reduce)").matches;if(e&&!t.force||l)return i();let g=.65,d=(1.8/g+.6)*1e3,u=document.createElement("div");u.className="pp-intro-overlay",u.setAttribute("role","presentation");let s=document.createElement("canvas");s.setAttribute("aria-hidden","true");let p=document.createElement("button");p.type="button",p.textContent="Passer",p.className="pp-intro-skip",u.appendChild(s),u.appendChild(p),document.body.appendChild(u);let o=!1,h=null,c=()=>{if(!o){o=!0;try{sessionStorage.setItem("pp-intro","1")}catch{}u.classList.add("pp-intro-out"),a.classList.remove("pp-intro"),setTimeout(()=>{try{h&&h.dispose()}catch{}u.remove()},900)}};p.addEventListener("click",c),u.addEventListener("click",c),setTimeout(c,9e3);try{let y=ye({...ie,...Se.light,logo:t.logo,ending:"logo",logoColor:"original",tile:!1,depth:2.3,dispersion:.25,relief:.55,caustics:2.3,highlights:2.6,bloom:1.9,dropStrength:1.6,decay:2.4,echoTint:.2,speed:g,background:"#f6e9d7"});if(h=Re(s,y,()=>{u.setAttribute("data-ready",""),setTimeout(c,d)}),!h)return c()}catch{c()}})()});Ve();})();
/*!
ReactDrops Component License 1.0

Copyright (c) 2026 ReactDrops

1. Scope and definitions

This license applies to ReactDrops software and associated documentation that
expressly carry this license or are distributed under a LICENSE file containing
it (the "Software"). "Licensor" means the copyright holder granting rights in
the Software, and only to the extent that holder has authority to grant them.
"You" means the individual or entity exercising these rights.

An "End Product" is a website, application, service, or other finished project
whose primary purpose is something other than providing reusable components,
source code, templates, or development assets to others.

2. Permitted uses

Subject to this license, Licensor grants You a worldwide, non-exclusive,
royalty-free license to use, copy, modify, and incorporate the Software into
unlimited personal, internal, and commercial End Products. You may charge for
End Products, subscriptions, development services, and work for clients.

You may distribute the Software as an integrated part of an End Product,
including in browser-delivered JavaScript. You may provide End Product source
code to a client, and share the Software with employees and contractors who
need it to develop or maintain End Products. Those recipients may use the
Software for those purposes subject to this license. This permission does not
authorize them to redistribute the Software as a reusable development asset.

3. Restricted redistribution

Unless You obtain separate written permission from Licensor, You may not sell,
sublicense, publish, share, or otherwise redistribute the Software, or a
substantial portion of it, whether unchanged or modified:

(a) as a standalone component, component library, UI kit, source-code bundle,
    registry, or other collection of reusable development assets;
(b) as part of a theme, template, starter project, or similar product offered
    to multiple recipients for reuse in their own projects; or
(c) through a builder or generation service that offers the Software as
    reusable blocks or source-code exports for others' projects.

These restrictions apply to paid and free redistribution. Renaming, restyling,
repackaging, translating, or modifying the Software does not remove them.
Building separate finished websites or applications for multiple clients is
permitted; offering a reusable template or kit containing the Software is not.

Public source-code hosting by Licensor is not permission to republish the
Software under another license. This license does not override any separate
rights granted directly by Licensor or applicable code-hosting terms.

4. Notices and ownership

Retain this license and applicable copyright and third-party notices in source
copies of the Software and permitted source distributions. No visible credit
or ReactDrops logo is required in an End Product's user interface.

Licensor retains ownership of its Software. You retain rights in Your own
contributions, subject to the license for any incorporated Software. No rights
to trademarks, trade names, or logos are granted by this license.

5. Third-party materials and separate grants

Dependencies, fonts, images, videos, and other third-party materials remain
subject to their respective licenses. Separately identified third-party code
is licensed under its stated terms, and these restrictions do not limit rights
granted by its copyright holders. Retain all required third-party notices.
Demo media are not licensed by this document; obtain Your own permission or
replace them with media You are entitled to use.

This license does not revoke rights granted under other valid licenses. It does
not assert ownership of third-party work or grant rights Licensor lacks.

6. Termination

The permissions granted here continue unless terminated for a material breach.
If You fail to cure a material breach within 30 days after receiving written
notice from Licensor, Your permissions terminate. On termination, cease uses
and distributions requiring this license. Rights under independently granted
licenses and rights that applicable law does not allow to be restricted remain
unaffected. Sections 3 through 7 survive termination.

7. Disclaimer

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT. TO THE MAXIMUM EXTENT
PERMITTED BY APPLICABLE LAW, LICENSOR AND CONTRIBUTORS SHALL NOT BE LIABLE FOR
ANY CLAIM, DAMAGES, OR OTHER LIABILITY, WHETHER IN CONTRACT, TORT, OR OTHERWISE,
ARISING FROM, OUT OF, OR IN CONNECTION WITH THE SOFTWARE OR ITS USE.

This license does not limit rights or exceptions that applicable law makes
non-waivable. No other permissions are granted by implication.
*/
